import { useEffect, useState } from "react";
import { callApi } from "../../services/ApiServices";
import CommonLoader from "../common/CommonLoader";
import { ImagePath } from "../common/ImagePath";
import CommonPagination from "../common/CommonPagination";

const ContactUs = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [contactUsListing, setContactUsListing] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const limit = 10;
  useEffect(() => {
    fetchContactUsListing(currentPage, limit, searchQuery);
  }, []);

  const fetchContactUsListing = async (page, limit, search) => {
    try {
        let apiUrl = `contact-us/list?page=${page}&limit=${limit}`;
        if(search) {
          apiUrl += `&search=${search}`
        }
        if(!search){
          setLoading(true)
        }
      const response = await callApi({
        method: "get",
        url: apiUrl
      });
      console.log("Contact", response);

      setContactUsListing(response?.data);
      setLoading(false);
       const totalitems = response?.pagination?.total
    const totalPages = Math.ceil(totalitems / limit);
    setTotalCount(totalPages)
    } catch (error) {
      console.error("Error fetching contact us listing:", error);
      setLoading(false);
    }
  };


  const handleMessageClick = (message) => {
    if (message && message.length > 20) {
    setSelectedMessage(message);
    setShowMessageModal(true);
  }
};
const handlePageChange =(e)=>{
  setCurrentPage(e)
  fetchContactUsListing(e, limit, searchQuery)
}
  return (
    <div className="space-y-6">
      {/* Search Bar */}
      {loading && <CommonLoader fullScreen />}
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-1 max-w-[314px]">
        <div className="relative">
          <svg
            className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-textcolor"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          <input
            type="text"
            placeholder="Search by email..."
            value={searchQuery}
            onChange={(e) =>{ setSearchQuery(e.target.value)
              setCurrentPage(1)
              fetchContactUsListing(1, limit, e.target.value)
            }}
              onKeyDown={(e) => {
              if (e.key === " " && searchQuery?.length === 0) {
                e.preventDefault();
              }
            }}
            className="w-full pl-10 pr-4 py-2.5 border-0 focus:outline-none text-base text-textcolor placeholder:text-textcolor"
          />
        </div>
      </div>

      {/* Advertisers Table */}
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-[#fafafa] border-b border-gray-200">
              <tr>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  First Name
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Last Name
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Email
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Message
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {contactUsListing?.length > 0 ? (
                contactUsListing?.map((contact, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-50 transition-colors"
                  >
                    <td className="px-6 py-3">
                      {contact?.contact_us_firstName || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {contact?.contact_us_lastName || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {contact?.contact_us_email || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {contact?.contact_us_message ? (
                        contact?.contact_us_message?.length > 30 ? (
                          <span
                            onClick={() =>
                              handleMessageClick(contact?.contact_us_message)
                            }
                            className="text-blue-600 cursor-pointer hover:underline"
                          >
                            {contact?.contact_us_message?.slice(0, 20)}...
                          </span>
                        ) : (
                          contact?.contact_us_message
                        )
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="4"
                    className="px-6 py-3 text-sm font-normal text-textcolor"
                  >
                    <div className="flex justify-center items-center mt-5">
                      <img
                        src={ImagePath?.NoDataFound}
                        alt="No Data Found"
                        style={{ width: 70, height: 70 }}
                      />
                    </div>
                    <p className="text-xl mt-2 text-center">No data found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <MessageModal
            show={showMessageModal}
            onClose={() => setShowMessageModal(false)}
            selectedMessage={selectedMessage}
          />
        </div>
      </div>
          <CommonPagination
        pageCount={totalCount}
        currentPage={currentPage}
        onPageChange={(e) => handlePageChange(e)}
      />
    </div>
  );
};

export default ContactUs;

const MessageModal = ({ show, onClose, selectedMessage }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-800">Message</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-xl"
          >
            ✕
          </button>
        </div>

        <div className="max-h-60 overflow-y-auto text-sm text-gray-700">
          {selectedMessage}
        </div>

        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-800 text-white text-sm rounded hover:bg-gray-900"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
